import { configureStore } from "@reduxjs/toolkit";
import videoReducer from "./slices/videoSlice";
import appReducer from "./slices/appSlice";
import homeReducer from "./slices/homeSlice";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import cohostReducer from "./slices/cohostSlice";

export const store = configureStore({
  reducer: {
    video: videoReducer,
    app: appReducer,
    content: homeReducer,
    auth: authReducer,
    userData: userReducer,
    cohosts: cohostReducer,
  },
});
